const QuotaDisplay = ({ remainingChars, totalChars }) => {
  const percentage = Math.round((remainingChars / totalChars) * 100);

  return (
    <div className="flex flex-col lg:items-center md:items-end">
      <div className="text-[clamp(0.75rem,1.5vw,0.875rem)] mb-[0.5rem]">
        <span className="font-semibold text-[#B0B4BB]">Credits Left:</span>
        <span className="text-[#B0B4BB] ml-[0.5rem]">
          {remainingChars.toLocaleString()} / {totalChars.toLocaleString()}
          <span className="text-[#7C8085] ml-[0.25rem]">
            ({percentage}%)
          </span>
        </span>
      </div>
      <div className="w-full h-[0.5rem] bg-white rounded-full overflow-hidden">
        <div
          className="h-full bg-[#178A94] transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default QuotaDisplay;